module.exports = __webpack_public_path__ + "img/r3.d2e36df3.jpg";